import type { BoxProps } from '@withjoy/joykit';
import { Box } from '@withjoy/joykit';
import React from 'react';
import { GALLERY_COLUMNS, GALLERY_TILE_GAP_PX, gridTemplateColumnsFor } from './galleryColumns';

interface TileGridProps {
  children: React.ReactNode;
  columns?: BoxProps['gridTemplateColumns'];
}

// See `gridTemplateColumnsFor` for why the tracks are fixed `calc()` lengths, not `1fr`.
const DEFAULT_RESPONSIVE_COLUMNS: TileGridProps['columns'] = gridTemplateColumnsFor(GALLERY_COLUMNS);

export const TileGrid = (props: TileGridProps) => {
  const { children, columns = DEFAULT_RESPONSIVE_COLUMNS } = props;

  return (
    <Box
      display="grid"
      maxWidth="100%"
      gridTemplateColumns={columns}
      alignItems="start"
      gap={`${GALLERY_TILE_GAP_PX}px`}
      paddingBottom={8}
    >
      {children}
    </Box>
  );
};
